export default __webpack_public_path__ + "static/media/unavailable.749fab6f.svg";